/* RackHunt Brand Watch — capture page logic (18–19 Oct 2026).
   Talks to the backend through the Shopify app proxy (form[data-proxy]).
   GET  -> { brands: [], sizes: {letter,numeric,waist,shoe,kids}, active: bool }
   POST -> same shape; the backend takes the customer id from Shopify's
           signed logged_in_customer_id, never from this payload.
   URL prefill: ?brands=A,B&size=L&src=thank_you
   Popular brands: #rh-bw-popular[data-brands] (section setting); search covers the rest. */
(function () {
  'use strict';

  var form = document.getElementById('rh-bw-form');
  var loginLink = document.getElementById('rh-bw-login');
  if (loginLink) {
    // Keep the prefill through the login round-trip.
    var back = location.pathname + location.search;
    var sep = loginLink.href.indexOf('?') === -1 ? '?' : '&';
    loginLink.href = loginLink.href + sep + 'return_to=' + encodeURIComponent(back);
  }
  if (!form) return;

  var PROXY = form.dataset.proxy || '/apps/bokbo/watch';
  var SYSTEMS = ['letter', 'numeric', 'waist', 'shoe', 'kids'];
  var params = new URLSearchParams(location.search);
  var source = params.get('src') || 'account';

  var vendors = [];
  try { vendors = JSON.parse(document.getElementById('rh-bw-vendors').textContent) || []; } catch (e) {}
  var vendorIndex = {};
  vendors.forEach(function (v) { vendorIndex[norm(v)] = v; });

  var state = { brands: [], sizes: {}, active: false, loaded: false };

  var selectedEl = document.getElementById('rh-bw-selected');
  var popularEl = document.getElementById('rh-bw-popular');
  var input = document.getElementById('rh-bw-brand-input');
  var suggestEl = document.getElementById('rh-bw-suggestions');
  var sizesEl = document.getElementById('rh-bw-sizes');
  var statusEl = document.getElementById('rh-bw-status');
  var saveBtn = document.getElementById('rh-bw-save');
  var stopBtn = document.getElementById('rh-bw-stop');

  var popular = [];
  if (popularEl) {
    popular = (popularEl.dataset.brands || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean)
      .map(function (s) { return vendorIndex[norm(s)] || s; });
  }

  function norm(s) { return String(s || '').trim().toLowerCase(); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  /* ---------- size classification (same rules as rh-size-prompt.js) ---------- */
  function classifySize(raw) {
    var v = String(raw || '').trim();
    if (!v) return null;
    var u = v.toUpperCase().replace(/\s+/g, '');
    if (/^(XXS|XS|S|M|L|XL|XXL|XXXL|[1-6]X|[1-6]XL)$/.test(u)) {
      if (/^[1-6]XL$/.test(u)) u = u.replace('XL', 'X');
      return { system: 'letter', value: u };
    }
    if (/^(NB|\d{1,2}-\d{1,2}M|\d{1,2}M|[2-5]T|\d{1,2}Y)$/.test(u)) return { system: 'kids', value: u };
    var m = u.match(/^US(\d{1,2}(\.5)?)$/);
    if (m) return { system: 'shoe', value: m[1] };
    if (/^\d{1,2}\.5$/.test(u)) return { system: 'shoe', value: u };
    if (/^00$/.test(u)) return { system: 'numeric', value: '00' };
    if (/^\d{1,2}$/.test(u)) {
      var n = parseInt(u, 10);
      if (n >= 23 && n <= 50) return { system: 'waist', value: String(n) };
      if (n <= 22) return { system: 'numeric', value: String(n) };
    }
    return null;
  }

  /* ---------- rendering ---------- */
  function renderBrands() {
    selectedEl.innerHTML = '';
    if (!state.brands.length) {
      var empty = document.createElement('span');
      empty.className = 'rh-bw__empty';
      empty.textContent = 'No brands yet';
      selectedEl.appendChild(empty);
    }
    state.brands.forEach(function (b) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'rh-bw__chip rh-bw__chip--on';
      chip.setAttribute('aria-label', 'Remove ' + b);
      chip.innerHTML = esc(b) + '<span class="rh-bw__chip-x" aria-hidden="true">&times;</span>';
      chip.addEventListener('click', function () {
        state.brands = state.brands.filter(function (x) { return x !== b; });
        renderBrands();
      });
      selectedEl.appendChild(chip);
    });
    renderPopular();
  }

  function renderPopular() {
    if (!popularEl) return;
    popularEl.innerHTML = '';
    var chosen = {};
    state.brands.forEach(function (b) { chosen[norm(b)] = true; });
    popular.forEach(function (b) {
      if (chosen[norm(b)]) return;
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'rh-bw__chip';
      chip.textContent = '+ ' + b;
      chip.setAttribute('aria-label', 'Watch ' + b);
      chip.addEventListener('click', function () { addBrand(b, true); });
      popularEl.appendChild(chip);
    });
    popularEl.parentElement.hidden = !popularEl.children.length;
  }

  function renderSizes() {
    sizesEl.querySelectorAll('.rh-bw__size-group').forEach(function (group) {
      var system = group.dataset.system;
      var wrap = group.querySelector('.rh-bw__chips');
      if (!wrap.children.length) {
        wrap.dataset.values.split(',').forEach(function (val) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'rh-bw__chip';
          chip.dataset.value = val;
          chip.textContent = val;
          chip.setAttribute('aria-pressed', 'false');
          chip.addEventListener('click', function () {
            state.sizes[system] = state.sizes[system] === val ? null : val;
            renderSizes();
          });
          wrap.appendChild(chip);
        });
      }
      wrap.querySelectorAll('.rh-bw__chip').forEach(function (chip) {
        var on = state.sizes[system] === chip.dataset.value;
        chip.classList.toggle('rh-bw__chip--on', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function setStatus(msg, kind) {
    statusEl.textContent = msg || '';
    statusEl.className = 'rh-bw__status' + (kind ? ' rh-bw__status--' + kind : '');
  }

  function render() {
    renderBrands();
    renderSizes();
    stopBtn.hidden = !state.active;
    saveBtn.textContent = state.active ? 'Save changes' : saveBtn.dataset.label || saveBtn.textContent;
  }

  /* ---------- brand search ---------- */
  function suggest(q) {
    var query = norm(q);
    suggestEl.innerHTML = '';
    if (!query) { suggestEl.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }
    var chosen = {};
    state.brands.forEach(function (b) { chosen[norm(b)] = true; });
    var hits = vendors.filter(function (v) {
      var n = norm(v);
      return !chosen[n] && n.indexOf(query) !== -1;
    }).sort(function (a, b) {
      var sa = norm(a).indexOf(query) === 0 ? 0 : 1;
      var sb = norm(b).indexOf(query) === 0 ? 0 : 1;
      return sa - sb || a.localeCompare(b);
    }).slice(0, 8);
    if (!hits.length) { suggestEl.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }
    hits.forEach(function (v) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.textContent = v;
      li.addEventListener('mousedown', function (e) { e.preventDefault(); addBrand(v); });
      suggestEl.appendChild(li);
    });
    suggestEl.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }

  function addBrand(v, keepFocus) {
    if (state.brands.indexOf(v) === -1) state.brands.push(v);
    input.value = '';
    suggest('');
    renderBrands();
    if (!keepFocus) input.focus();
  }

  input.addEventListener('input', function () { suggest(input.value); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      var first = suggestEl.querySelector('li');
      var exact = vendorIndex[norm(input.value)];
      if (exact) addBrand(exact); else if (first) addBrand(first.textContent);
    } else if (e.key === 'Escape') {
      suggest('');
    }
  });
  input.addEventListener('blur', function () { setTimeout(function () { suggest(''); }, 150); });

  /* ---------- prefill from URL ---------- */
  function applyPrefill() {
    var brandsParam = params.get('brands');
    if (brandsParam) {
      brandsParam.split(',').forEach(function (raw) {
        var v = vendorIndex[norm(raw)];
        if (v && state.brands.indexOf(v) === -1) state.brands.push(v);
      });
    }
    var sizeParam = params.get('size');
    if (sizeParam) {
      sizeParam.split(',').forEach(function (raw) {
        var c = classifySize(raw);
        if (c && !state.sizes[c.system]) state.sizes[c.system] = c.value;
      });
    }
    // Fall back to the size memory the search page keeps.
    try {
      var remembered = JSON.parse(localStorage.getItem('rh_sizes') || '{}');
      SYSTEMS.forEach(function (s) {
        if (!state.sizes[s] && remembered[s]) {
          var c = classifySize(remembered[s]);
          if (c && c.system === s) state.sizes[s] = c.value;
        }
      });
    } catch (e) {}
  }

  /* ---------- backend ---------- */
  function request(method, body) {
    return fetch(PROXY, {
      method: method,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
  }

  function load() {
    request('GET').then(function (r) {
      if (r.status === 404 || r.status === 501) {
        setStatus('Brand notifications are almost ready — you can set them up, but saving isn’t switched on yet.', 'warn');
        return null;
      }
      if (r.status === 401) { location.href = loginUrl(); return null; }
      if (!r.ok) return null;
      return r.json();
    }).then(function (data) {
      if (data && data.brands) {
        state.brands = data.brands.slice();
        state.sizes = data.sizes || {};
        state.active = !!data.active;
      }
      applyPrefill();
      state.loaded = true;
      render();
    }).catch(function () {
      applyPrefill();
      render();
    });
  }

  function loginUrl() {
    return '/account/login?return_to=' + encodeURIComponent(location.pathname + location.search);
  }

  function cleanSizes() {
    var out = {};
    SYSTEMS.forEach(function (s) { if (state.sizes[s]) out[s] = state.sizes[s]; });
    return out;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!state.brands.length) { setStatus('Add at least one brand to watch.', 'error'); input.focus(); return; }
    var sizes = cleanSizes();
    if (!Object.keys(sizes).length) { setStatus('Pick your size so we only show things that fit.', 'error'); return; }
    saveBtn.disabled = true;
    setStatus('Saving…');
    request('POST', { brands: state.brands, sizes: sizes, active: true, frequency: 'weekly', source: source })
      .then(function (r) {
        if (r.status === 401) { location.href = loginUrl(); return; }
        if (r.status === 404 || r.status === 501) { setStatus('Saving isn’t switched on yet — please try again in a few days.', 'warn'); return; }
        if (!r.ok) { setStatus('Something went wrong. Please try again.', 'error'); return; }
        state.active = true;
        render();
        var n = state.brands.length;
        setStatus('Done — watching ' + n + ' brand' + (n === 1 ? '' : 's') + ' in your size. We’ll email you only when something new comes in.', 'ok');
      })
      .catch(function () { setStatus('Something went wrong. Please try again.', 'error'); })
      .then(function () { saveBtn.disabled = false; });
  });

  stopBtn.addEventListener('click', function () {
    stopBtn.disabled = true;
    request('POST', { brands: state.brands, sizes: cleanSizes(), active: false, frequency: 'weekly', source: source })
      .then(function (r) {
        if (!r.ok) { setStatus('Something went wrong. Please try again.', 'error'); return; }
        state.active = false;
        render();
        setStatus('Notifications stopped. Your brands are kept so you can switch them back on any time.', 'ok');
      })
      .catch(function () { setStatus('Something went wrong. Please try again.', 'error'); })
      .then(function () { stopBtn.disabled = false; });
  });

  saveBtn.dataset.label = saveBtn.textContent;
  render();
  load();
})();
